module.exports = __webpack_public_path__ + "static/media/match-pairs-bg.f6da13bd.svg";